import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const timeLeft = useCountdown(11);
  return <div className="fixed top-0 left-0 w-full bg-gradient-to-r from-red-600 to-orange-600 text-white py-1 z-50 text-center font-bold text-[10px] md:text-xs shadow-lg" data-id="element-10">
      <div className="flex items-center justify-center gap-1.5" data-id="element-11">
        <Clock className="w-2.5 h-2.5 md:w-3 md:h-3 animate-pulse" data-id="element-12" />
        <span className="tracking-wide" data-id="element-13">
          ⚡ OFERTA EXPIRA EN: {timeLeft} | SOLO QUEDAN 3 CUPOS ⚡
        </span>
      </div>
    </div>;
}